const usePermissionConfig = () => {
  return {
    /*
    * 保存配置
    * 控制：保存IOS配置；保存Android配置
    * 跳转路由名称：
    * */
    UPDATE: 'OPS-AGL-BBGXPZ-BCPZ',
  };
};

export default usePermissionConfig;
